import { gql } from "@apollo/client";

export const UPDATE_DOMAIN = gql`
  mutation updateDomain($input: UpdateDomainInput!) {
    updateDomain(input: $input) {
      domain {
        id
        name
        companyKnowledgeBase
        avatar {
          name
          dir
          base
          mimetype
        }
      }
    }
  }
`;
